var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Modal from "../../UI/Modal/Modal";
import SecondaryNavLayout from "../../Layout/SecondaryNavLayout";
import SecondaryNavButton from "../../UI/SecondaryNav/SecondaryNavButton";
import FAIcon from "../../UI/FAIcon/FAIcon";
import ModalHeader from "../../UI/Modal/ModalHeader";
import UpdateFeed from "../ItemUpdate/UpdateFeed";
const ViewModal = (_a) => {
    var { actions, activityItemId, activityItemTypeId, children, hideFeed, disableCommenting } = _a, modalProps = __rest(_a, ["actions", "activityItemId", "activityItemTypeId", "children", "hideFeed", "disableCommenting"]);
    const [actionShowing, setActionShowing] = React.useState(null);
    React.useEffect(() => {
        if (!modalProps.isOpen) {
            setActionShowing(null);
        }
    }, [modalProps.isOpen]);
    React.useEffect(() => {
        // If actions have changed, we want to make sure that we are still selecting a valid action.  If not, revert back
        // to the default view.
        // @ts-expect-error - TS2531 - Object is possibly 'null'. | TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type 'undefined[] | Action'.
        if (actionShowing != null && !actions[actionShowing]) {
            setActionShowing(null);
        }
    }, [actionShowing, actions]);
    // @ts-expect-error - TS2531 - Object is possibly 'null'. | TS2339 - Property 'filter' does not exist on type 'undefined[] | Action'. | TS7006 - Parameter 'action' implicitly has an 'any' type.
    const definedActions = actions.filter((action) => action);
    const actionModalAndFooter = actionShowing != null &&
        definedActions[actionShowing] &&
        definedActions[actionShowing].modalBodyAndFooter;
    const search = React.useMemo(() => ({
        global: {
            items: [
                {
                    itemIdInt: typeof activityItemId === "number" ? activityItemId : null,
                    itemIdUUID: typeof activityItemId !== "number" ? activityItemId : null,
                    activityItemTypeId,
                },
            ],
            activityItemTypeIds: [activityItemTypeId],
        },
        latestValue: [],
    }), [activityItemId, activityItemTypeId]);
    return (_jsx(Modal, Object.assign({}, modalProps, { children: actionModalAndFooter ? (_jsxs(_Fragment, { children: [actionShowing != null && (_jsx(ModalHeader, { title: definedActions[actionShowing]
                        ? definedActions[actionShowing].title
                        : "", closeModal: modalProps.onModalClosed })), actionModalAndFooter({ cancelAction: () => setActionShowing(null) })] })) : (_jsx(SecondaryNavLayout, { dontFix: true, nav: _jsxs("div", { className: "d-flex align-items-center justify-content-between flex-grow-1", children: [_jsx("div", { className: "d-flex", children: definedActions.map((action, index) => (_jsx(React.Fragment, { children: _jsx(SecondaryNavButton, { icon: action.icon, label: action.title, title: typeof action.disabled === "string"
                                    ? action.disabled
                                    : action.title, disabled: !!action.disabled, onClick: () => setActionShowing(index) }) }, index))) }), _jsx("button", { className: "btn btn-link text-dark", onClick: () => modalProps.onModalClosed(), children: _jsx(FAIcon, { icon: "times", title: "Close", srText: "Close this modal" }) })] }), children: _jsxs("div", { className: "modal-body", style: { backgroundColor: "#F9F9FB" }, children: [children, !hideFeed && (_jsx("div", { className: "mt-4", children: modalProps.isOpen && (_jsx(UpdateFeed, { hideItemUpdatePaths: true, hideFormattedText: true, search: search, pageSize: 5, disableCommenting: disableCommenting, commentContext: { activityItemTypeId, id: activityItemId } })) }))] }) })) })));
};
export default ViewModal;
